import { formatOneGraphData } from '../../navigationMenuParser';
import { geoCountryCode, locales } from '../../types';
import { englishContentIntl, englishContentUS } from './english';
import { koreanContentIntl, koreanContentUS } from './korean';
import { spanishContentIntl, spanishContentUS } from './spanish';
import { turkishContentIntl, turkishContentUS } from './turkish';
export function getSignedOutHeaderNavLinks(locale, countryCode) {
  var signedOutHeaderNavLinks = {};

  switch (locale) {
    case locales['es-419']:
    case locales.es:
      signedOutHeaderNavLinks = countryCode === geoCountryCode.US ? spanishContentUS : spanishContentIntl;
      break;

    case locales.ko:
      signedOutHeaderNavLinks = countryCode === geoCountryCode.US ? koreanContentUS : koreanContentIntl;
      break;

    case locales.tr:
      signedOutHeaderNavLinks = countryCode === geoCountryCode.US ? turkishContentUS : turkishContentIntl;
      break;

    default:
      signedOutHeaderNavLinks = countryCode === geoCountryCode.US ? englishContentUS : englishContentIntl;
  }

  return formatOneGraphData(signedOutHeaderNavLinks);
}